import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";

export class DjPsychoXSymTransform extends PIXI.Container implements StageLayer {

    constructor() {
        super();
        this.name = "DjPsychoXSymTransform";
    }

    public playXSymTransformAnimation(reelId: number, symId: number, symName: string): TimelineLite {
        const item: PIXI.spine.Spine = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("xSymTransform")),
            tl: TimelineLite = new TimelineLite();

        tl.add([
            () => {
                item.position.set((DjPsycho.reelViewX + (reelId * DjPsycho.symbolWidth) + DjPsycho.symbolWidth / 2 + (reelId * DjPsycho.padding)), (DjPsycho.reelViewY + (symId * DjPsycho.symbolHeight) + (symId * DjPsycho.padding)));

                this.addChild(item);
            },
            DjPsycho.createTimelineForAnimation(item, 0, symName + "_Transform", false)
        ]);
        tl.add(() => {
            if (item.parent) {
                this.removeChild(item);
            }
        });

        return tl;
    }
}